<template>
    <ion-page>
        <ion-loading :is-open="busy" message="Loading, please wait"/>
        <standard-header title="Returns Locations" align="middle"/>
        <ion-content>
            <ion-list>
                <ion-item>
                    <ion-label><h2>Locations</h2></ion-label>
                </ion-item>
                <ion-item lines="none" v-for="location in locations" :key="location.id" button detail @click="chooseLocation(location)">
                    <ion-label class="ion-text-wrap">
                        <h2>
                            {{ location.code }}
                            <ion-badge v-if="location.is_temporary">temp</ion-badge>
                        </h2>
                        <p>
                            {{ location.description }}
                        </p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>

</template>

<script>
import StandardHeader from "@/components/StandardHeader";
import {
    IonContent,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonBadge,
    IonLoading
} from "@ionic/vue";
import {checkmarkCircle, search, barcode, listOutline} from 'ionicons/icons';


export default {
    name: "ReturnLocationsList",
    inject: ['$http', '$toast', '$validationAlert'],
    components: {
        StandardHeader,
        IonLoading,
        IonContent, IonItem, IonLabel, IonList, IonPage, IonBadge
    },
    props: {
        type: String
    },
    ionViewDidEnter() {
        this.refresh();
    },
    methods: {
        chooseLocation(location) {
            this.$router.push({
                name: 'warehouse.returns.location.items',
                params: {
                    // passing locationCode so that next page doesn't have
                    // to do an API call just to get the location code
                    locationId: location.id
                }, query: {
                    locationCode: location.code,
                }
            })
        },
        refresh() {
            this.busy = true;
            this.$http
                .get(`/api/locations`, {params: {returns_only: true, all: true, include: 'zone'}})
                .then(response => {
                    this.locations = response.data.items;
                    console.log(response.data);
                }).catch(error => {
                    this.$validationAlert(error);
                }).finally(() => {
                    this.busy = false;
                });
        },
    },
    data() {
        return {
            locations: [],
            busy: false
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline
        }
    }
}
</script>

<style scoped>

</style>